module.exports = __webpack_public_path__ + "img/scan.890db197.png";